<div class="container">
  <mat-card style="min-height: 200px">
    <mat-card-title class="text-center">
      Payment Completed <mat-icon>check_circle</mat-icon>
    </mat-card-title>
  </mat-card>
</div>
